import React from 'react';
import { Typography } from '@mui/material';

const DateInfo = ({ checkIn, checkOut, nights, passengersCount }) => {
  const textBaseSx = {
    color: 'black',
    fontSize: { xs: 18, sm: 16, md: 15 },
    lineHeight: 1.5,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  };

  return (
    <>
      <Typography sx={textBaseSx}>
        In {checkIn.format('DD/MM/YYYY')} - Out {checkOut.format('DD/MM/YYYY')}
      </Typography>
      <Typography sx={textBaseSx}>
        {nights} noche{nights > 1 ? 's' : ''}, {passengersCount} huésped
        {passengersCount > 1 ? 'es' : ''}
      </Typography>
    </>
  );
};

export default DateInfo;
